import React, { Component } from "react";
import Routes from "./Routes";
import { withHeaderFooter, withScroll } from "./HOC";

class App extends Component {
  render() {
    return <Routes />;
  }
}

export default withScroll(withHeaderFooter(App));
